"use strict";

/**
 * PagedData is an object that is used as a property of a peer node. It provides a way to page in
 * subsets of the data on the server side.
 */
define(["dojo/_base/declare"], function (declare) {
  return declare([], {
    constructor: function constructor(args) {
      args = args || {};
      this._peerNode = args.peerNode;
      this._propertyKey = args.propertyKey;
      this._partialData = args.partialData || [];
      this._rowCount = args.rowCount || 0;
      this._columnCount = args.columnCount || 0;
      this._currentStartRow = args.currentStartRow || 0;
      this._currentEndRow = args.currentEndRow || 0;
      this._currentStartCol = args.currentStartCol || 0;
      this._currentEndCol = args.currentEndCol || 0;
      this._queuedOperations = [];
    },
    setPeerNode: function setPeerNode(peerNode, propertyKey) {
      this._peerNode = peerNode;
      this._propertyKey = propertyKey;
      var i;
      for (i = 0; i < this._queuedOperations.length; i += 1) {
        this._queuedOperations[i].apply(this);
      }
      this._queuedOperations = [];
    },
    getPartialData: function getPartialData() {
      return this._partialData;
    },
    getRowCount: function getRowCount() {
      return this._rowCount;
    },
    getColumnCount: function getColumnCount() {
      return this._columnCount;
    },
    getCurrentStartRow: function getCurrentStartRow() {
      return this._currentStartRow >= 0 ? this._currentStartRow : 0;
    },
    getCurrentEndRow: function getCurrentEndRow() {
      return this.getCurrentStartRow() + this._partialData.length;
    },
    getCurrentStartCol: function getCurrentStartCol() {
      return this._currentStartCol >= 0 ? this._currentStartCol : 0;
    },
    getCurrentEndCol: function getCurrentEndCol() {
      if (this._partialData.length > 0) {
        if (Array.isArray(this._partialData[0])) {
          return this.getCurrentStartCol() + this._partialData[0].length;
        } else {
          return 1;
        }
      } else if (this._currentEndCol >= 0) {
        return this._currentEndCol;
      } else {
        return 0;
      }
    },
    changeData: function changeData(startRow, startCol, newData) {
      if (!this._peerNode) {
        this._queuedOperations.push(function () {
          this.changeData(startRow, startCol, newData);
        });
        return;
      }

      // update the data in place
      var i, j;
      for (i = 0; i < newData.length; i += 1) {
        var oldRow = this._partialData[startRow - this._currentStartRow + i];
        var newRow = newData[i];
        for (j = 0; j < newRow.length; j += 1) {
          oldRow[startCol - this._currentStartCol + j] = newRow[j];
        }
      }
      var that = this;
      setTimeout(function () {
        that._peerNode.dispatchEvent("peerEvent", that._peerNode, {
          type: "changeData",
          key: that._propertyKey,
          startRow: startRow,
          startCol: startCol,
          newData: newData
        });
      }, 0);
    },
    updatePartialData: function updatePartialData(startRow, endRow, startCol, endCol) {
      if (startRow === this._currentStartRow && startCol === this._currentStartCol && endRow === this._currentEndRow && endCol === this._currentEndCol) {
        return;
      }
      if (!this._peerNode) {
        // early return if there is no peer node specified. this can happen if the paged
        // data is being used separately from a node (tests).
        this._queuedOperations.push(function () {
          this.updatePartialData(startRow, endRow, startCol, endCol);
        });
        return;
      }
      if (typeof startCol === "undefined" || typeof endCol === "undefined") {
        startCol = -1;
        endCol = -1;
      }
      this._peerNode.dispatchEvent("peerEvent", this._peerNode, {
        type: "partialUpdate",
        key: this._propertyKey,
        startRow: startRow,
        startCol: startCol,
        endRow: endRow,
        endCol: endCol
      });
    }
  });
});
//# sourceMappingURL=PagedData.js.map
